export const isCarteCora = (numCarte) => {
  return numCarte.indexOf("9") === 0;
}
